import {useIntl} from 'react-intl'
import BreadCrumb from '../../../_metronic/layout/components/breadcrumb'
import SalesAnalysis from 'src/feature/analytics/component/sections/AverageAnalytics'
import TotalRevenue from 'src/feature/analytics/component/sections/TotalRevenue'
import NumberOfOrders from 'src/feature/analytics/component/sections/NumberOfOrders'
import {
  useGetOrderAnalytics,
  useGetRevenueAnalytics,
  useGetAverageAnalytics,
  useGetMemberAnalytics,
} from 'src/feature/analytics/context/useGetAnalytics'
import {useState} from 'react'

export default function DashboardPage() {
  const intl = useIntl()
  const [period, setPeriod] = useState(3)
  const {data: orderAnalyticsData, isLoading: isLoadingOrderAnalytics} =
    useGetOrderAnalytics(period)
  const {data: revenueAnalyticsData, isLoading: isLoadingRevenueAnalytics} =
    useGetRevenueAnalytics(period)
  const {data: averageAnalyticsData, isLoading: isLoadingAverageAnalytics} =
    useGetAverageAnalytics(period)
  const {data: memberAnalytics, isLoading: isLoadingMemberAnalytics} = useGetMemberAnalytics(period)

  // const period = intl.formatMessage({ id: 'GLOBAL.IN_LAST_30_DAYS' });
  const periodText = () => {
    switch (period) {
      case 1:
        return intl.formatMessage({id: 'GLOBAL.IN_TODAY'})
      case 3:
        return intl.formatMessage({id: 'GLOBAL.IN_LAST_WEEK'})
      case 4:
        return intl.formatMessage({id: 'GLOBAL.IN_LAST_30_DAYS'})
      case 5:
        return intl.formatMessage({id: 'GLOBAL.IN_LAST_90_DAYS'})
      default:
        return ''
    }
  }

  function AnalyticsTitle({classname, intl}: {classname?: string; intl: any}) {
    return (
      <div className={classname}>
        <h3 className='fs-4 mb-0' style={{color: '#6C757D'}}>
          {intl.formatMessage({id: 'ANALYTICS.SUMMARY'})}{' '}
          <span style={{color: '#02acd2', fontWeight: 'normal'}}>
            {intl.formatMessage({id: 'ANALYTICS.SUMMARY.1'})}
          </span>{' '}
          {intl.formatMessage({id: 'ANALYTICS.SUMMARY.2'})}
        </h3>
      </div>
    )
  }

  return (
    <div>
      <div className=''>
        <AnalyticsTitle classname='d-block d-md-none w-100 mb-10' intl={intl} />
        <div className='d-flex justify-content-between align-items-center gap-10'>
          <BreadCrumb currentPage={intl.formatMessage({id: 'DASHBOARD'})} />
          <AnalyticsTitle classname='d-none d-md-block' intl={intl} />
          <select
            className='form-select form-select-solid w-150px w-md-200px bg-white border-light'
            data-control='select2'
            data-placeholder='Select an option'
            data-hide-search='true'
            value={period.toString()}
            disabled={
              isLoadingOrderAnalytics || isLoadingRevenueAnalytics || isLoadingAverageAnalytics
            }
            onChange={(e) => {
              setPeriod(Number(e.target.value))
            }}
          >
            <option value='5'>{intl.formatMessage({id: 'GLOBAL.LAST_90_DAYS'})}</option>
            <option value='4'>{intl.formatMessage({id: 'GLOBAL.LAST_30_DAYS'})}</option>
            <option value='3'>{intl.formatMessage({id: 'GLOBAL.LAST_WEEK'})}</option>
            <option value='1'>{intl.formatMessage({id: 'GLOBAL.TODAY'})}</option>
          </select>
        </div>
      </div>

      <div className='mt-5'>
        <SalesAnalysis
          member={memberAnalytics}
          average={averageAnalyticsData}
          period={periodText()}
          isLoading={isLoadingAverageAnalytics || isLoadingMemberAnalytics}
        />
      </div>

      <div className='d-flex w-100  gap-5 flex-column flex-md-row mt-5'>
        <div className='card w-100'>
          <TotalRevenue
            revenue={revenueAnalyticsData}
            period={periodText()}
            isLoading={isLoadingRevenueAnalytics}
          />
        </div>

        <div className='card w-100'>
          <NumberOfOrders
            order={orderAnalyticsData}
            period={periodText()}
            isLoading={isLoadingOrderAnalytics}
          />
        </div>
      </div>
    </div>
  )
}
